import type { TradeInAemVehicleExtraInfoType, TradeInAemVehicleType } from "../../utils/types";

export const TRADE_IN_AEM_FIND_VEHICLE_SET_VEHICLE = "tradeInAemVehicle/setVehicle";
export type TradeInAemSetVehicleType = {
    type: typeof TRADE_IN_AEM_FIND_VEHICLE_SET_VEHICLE;
    vehicle: TradeInAemVehicleType;
};
export const tradeInAemVehicleSetVehicle = (vehicle: TradeInAemVehicleType): TradeInAemSetVehicleType => ({
    type: TRADE_IN_AEM_FIND_VEHICLE_SET_VEHICLE,
    vehicle,
});

export const TRADE_IN_AEM_UPDATE_VEHICLE_PROP = "tradeInAemVehicle/updateVehicleProp";
export type TradeInAemUpdateVehicleProp = {
    type: typeof TRADE_IN_AEM_UPDATE_VEHICLE_PROP;
    key: string;
    value: string | string[];
};
export const tradeInAemUpdateVehicleProp = (key: string, value: string | string[]): TradeInAemUpdateVehicleProp => ({
    type: TRADE_IN_AEM_UPDATE_VEHICLE_PROP,
    key,
    value,
});

export const TRADE_IN_AEM_UPDATE_EXTRA_INFO_PROP = "tradeInAemVehicle/updateExtraInfoProp";
export type TradeInAemUpdateExtraInfoProp = {
    type: typeof TRADE_IN_AEM_UPDATE_EXTRA_INFO_PROP;
    key: keyof TradeInAemVehicleExtraInfoType;
    value: string | null;
};
export const tradeInAemUpdateExtraInfoProp = (
    key: keyof TradeInAemVehicleExtraInfoType,
    value: string | null,
): TradeInAemUpdateExtraInfoProp => ({
    type: TRADE_IN_AEM_UPDATE_EXTRA_INFO_PROP,
    key,
    value,
});

export type TradeInAemVehicleActionsType =
    | TradeInAemSetVehicleType
    | TradeInAemUpdateVehicleProp
    | TradeInAemUpdateExtraInfoProp;
